module.exports = __webpack_public_path__ + "static/media/ESS_tube.34402dd7.jpg";